export const CALENDAR_LABELS = {
  sameDay: "[Dzisiaj o] H:mm", // The same day ( Today at 2:30 AM )
  nextDay: "[Jutro o] H:mm", // The next day ( Tomorrow at 2:30 AM )
  nextWeek: "dddd [at] H:mm", // The next week ( Sunday at 2:30 AM )
  lastDay: "[Wczoraj o] H:mm", // The day before ( Yesterday at 2:30 AM )
  lastWeek: "dddd [o] H:mm", // Last week ( Last Monday at 2:30 AM )
  sameElse: "DD.MM.YYYY", // Everything else ( 17/10/2011 )
};
